import { useLocalObservable } from 'mobx-react-lite';

import Tasks from 'APP/Tasks';
import Entities from 'STORE';
import { InputPanel } from 'STORE/InputPanelsStore/InputPanel/InputPanel';
import { ChatMessage } from 'STORE/Messages/Message/ChatMessage/ChatMessage';

interface IRepliedMessagePresenter {
  inputPanel: InputPanel;
  message: ChatMessage | null;
  title: string;
  isReplyMode: boolean;
  endReply(): void;
}

export function useRepliedMessagePresenter(): IRepliedMessagePresenter {
  const presenter = useLocalObservable<IRepliedMessagePresenter>(() => ({
    get inputPanel(): InputPanel {
      return Entities.InputPanelsStore.activeInputPanel;
    },

    get message(): ChatMessage | null {
      return presenter.inputPanel.replyMessage || null;
    },

    get title(): string {
      const message = presenter.message;

      if (!message) {
        return '';
      }

      if (message.forward) {
        return message.forward.avatarTitle || '';
      }

      return message.avatarTitle || '';
    },

    get isReplyMode(): boolean {
      return Boolean(presenter.message);
    },

    endReply(): void {
      Tasks.messaging.endReplyMessage(null);
    },
  }));

  return presenter;
}
